export const tabelaVeiculoFilterConfig = [
  {
    id: 'NumeroFrota',
    type: 'text',
    label: 'Numero Frota',
    placeholder: 'Digite o numero da frota'
  },
  {
    id: 'IdTabelaPremiacao',
    type: 'number',
    label: 'Id Tabela Premiacao',
    placeholder: 'Digite o id da tabela'
  },
  {
    id: 'Ativo',
    type: 'checkbox',
    label: 'Ativo'
  }
];
